/**
 * Created by yangyue on 2017/9/1.
 */

module.exports = {
  API_SERVER: window.location.origin,
  MASTER_WEB_URL: 'http://auth.yukehulian.com',  // 生产环境,
  TOOLS_ID: '18',
  // MASTER_WEB_URL: 'http://authtest.yukehulian.com',  // 测试环境
  // TOOLS_ID: '20',
  HOST: window.location.origin
};



// WEBPACK FOOTER //
// ./src/configs/prod.js